import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';
import type { InfoNoteVariant } from './InfoNote.types';

const tone: Record<InfoNoteVariant, { bg: string; border: string; fg: string }> = {
  info: { bg: semantic.bg.infoSubtle, border: semantic.border.info, fg: semantic.text.info },
  warning: {
    bg: semantic.bg.warningSubtle,
    border: semantic.border.warning,
    fg: semantic.text.warning,
  },
  positive: {
    bg: semantic.bg.positiveSubtle,
    border: semantic.border.positive,
    fg: semantic.text.positive,
  },
  danger: {
    bg: semantic.bg.dangerSubtle,
    border: semantic.border.danger,
    fg: semantic.text.danger,
  },
  neutral: {
    bg: semantic.bg.surfaceSubtle,
    border: semantic.border.default,
    fg: semantic.text.primary,
  },
};

export const Wrapper = styled.div<{ $variant?: InfoNoteVariant }>`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
  margin: ${space['space-300']} 0;
  padding: ${space['space-300']} ${space['space-400']};
  background: ${(p) => tone[p.$variant ?? 'neutral'].bg};
  border: ${size.stroke['stroke-default']} solid ${(p) => tone[p.$variant ?? 'neutral'].border};
  border-radius: ${size.radius['radius-sm']};
  box-sizing: border-box;
`;

export const IconWrapper = styled.span<{ $variant?: InfoNoteVariant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => tone[p.$variant ?? 'neutral'].fg};
  flex-shrink: 0;
`;

export const NoteText = styled.span<{ $variant?: InfoNoteVariant }>`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${(p) => tone[p.$variant ?? 'neutral'].fg};
  flex: 1;
  min-width: 0;
`;

export const Divider = styled.span<{ $variant?: InfoNoteVariant }>`
  align-self: stretch;
  width: ${size.stroke['stroke-default']};
  background: ${(p) => tone[p.$variant ?? 'neutral'].border};
  flex-shrink: 0;
`;

export const DismissButton = styled.button<{ $variant?: InfoNoteVariant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: ${space['space-100']};
  background: none;
  border: none;
  cursor: pointer;
  line-height: 1;
  color: ${(p) => tone[p.$variant ?? 'neutral'].fg};
`;
